import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, Tabs, Tab,
  Box, Typography, Divider, Paper, List, ListItemButton, ListItemText
} from '@mui/material';

const ITENS = [
  { id: 'TEXT',  titulo: 'TEXT',  desc: 'Mensagem simples; pode usar {VARIAVEIS}.' },
  { id: 'CAPT',  titulo: 'CAPTURA', desc: 'Salva entrada do usuário em um campo (ex.: NOME).' },
  { id: 'ELO',   titulo: 'ELO',   desc: 'Ponte/jump para outra etapa. Sem saída.' },
  { id: 'RET',   titulo: 'RETURN',desc: 'Volta para o ELO indicado (retorno).' },
  { id: 'STOP',  titulo: 'STOP',  desc: 'Encerra o fluxo.' },
  { id: 'FILE',  titulo: 'FILE',  desc: 'Envia arquivo com legenda opcional.' },
  { id: 'VCARD', titulo: 'VCARD', desc: 'Envia contato (nome/telefone).' },
  { id: 'ATEND', titulo: 'ATENDIMENTO', desc: 'Transfere para humano/outro número.' },
  { id: 'GPT',   titulo: 'GPT',   desc: 'Resposta com IA; com WP roteia por intenção.' },
];

export default function HelpModal({ open, onClose }) {
  const [tab, setTab] = React.useState('exemplos');
  const [sel, setSel] = React.useState(ITENS[0].id);
  const item = React.useMemo(() => ITENS.find(i => i.id === sel) ?? ITENS[0], [sel]);

  const regras = (() => {
    switch (sel) {
      case 'CAPT': return [
        'Saída automática (sem label).',
        'Use * na aresta anterior para aceitar qualquer texto.',
        'Campo único: ex. NOME, CEP, EMAIL.',
      ];
      case 'ELO': return [
        'ELO não tem saída.',
        'Configure “destino” (ID numérico).',
        'Dica: duplo-clique navega ao destino.',
      ];
      case 'RET': return [
        'RETURN aponta para um ELO (retorno = ID do ELO).',
        'Se um RETURN usar o ELO, o ELO precisa ter “destino”.',
      ];
      case 'STOP': return ['Sem saída; use quando terminar.'];
      case 'FILE': return [
        'Preencha “Caminho do arquivo”.',
        'Apenas uma saída.',
        'Legenda opcional na mensagem.',
      ];
      case 'VCARD': return [
        'Preencha nome e telefone.',
        'Apenas uma saída.',
      ];
      case 'ATEND': return [
        'Mensagem curta explicando a transferência.',
        'Pode ter lembrete se não houver resposta.',
      ];
      case 'GPT': return [
        'Informe o modelo (ex.: gpt-4o, gpt-5-mini).',
        'Opcional: enviar histórico e limitar tokens.',
        'Para WP, peça resposta só com número (1,2,...).',
      ];
      default: return [
        'Conteúdo simples, suporta variáveis como {NOME}.',
        'Conecte para a próxima etapa.',
      ];
    }
  })();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Ajuda • exemplos e regras</DialogTitle>
      <DialogContent dividers>
        <Tabs value={tab} onChange={(_,v)=>setTab(v)} sx={{ mb: 2 }}>
          <Tab value="guia" label="Guia" />
          <Tab value="exemplos" label="Exemplos" />
        </Tabs>

        {tab === 'guia' && (
          <Box>
            <Typography variant="subtitle1" sx={{ mb: 1 }}>Como pensar os blocos</Typography>
            <ul style={{ margin: 0, paddingLeft: 18, lineHeight: 1.5 }}>
              <li><b>TEXT</b>: envia mensagem; pode usar {'{NOME}'}.</li>
              <li><b>CAPTURA</b>: armazena o que o usuário digitar (ex.: NOME).</li>
              <li><b>ELO</b>: ponte para outro nó; sem saída.</li>
              <li><b>RETURN</b>: volta para o ELO configurado.</li>
              <li><b>STOP</b>: finaliza o fluxo.</li>
              <li><b>FILE/VCARD</b>: envia arquivo/contato.</li>
              <li><b>ATENDIMENTO</b>: transfere humano.</li>
              <li><b>GPT</b>: resposta IA; com WP roteia por número.</li>
            </ul>
          </Box>
        )}

        {tab === 'exemplos' && (
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Paper variant="outlined" sx={{ width: 240, flexShrink: 0, maxHeight: 420, overflow: 'auto' }}>
              <List dense disablePadding>
                {ITENS.map(i => (
                  <ListItemButton key={i.id} selected={i.id===sel} onClick={()=>setSel(i.id)}>
                    <ListItemText
                      primary={i.titulo}
                      secondary={i.desc}
                      primaryTypographyProps={{ fontSize: 13, fontWeight: 600 }}
                      secondaryTypographyProps={{ fontSize: 12 }}
                    />
                  </ListItemButton>
                ))}
              </List>
            </Paper>

            <Box sx={{ flex: 1 }}>
              <Typography variant="subtitle2" sx={{ mb: 0.5 }}>{item.titulo}</Typography>
              <Typography sx={{ color: 'text.secondary', mb: 1 }}>{item.desc}</Typography>
              <Divider sx={{ my: 1 }} />
              <Typography variant="subtitle2">Regras rápidas</Typography>
              <ul style={{ margin: 0, paddingLeft: 18, lineHeight: 1.5 }}>
                {regras.map((r, i) => <li key={i}>{r}</li>)}
              </ul>
            </Box>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
}
